import type { SampleType } from "@/contracts/base";
import i18n from "@/i18n";

export const getSampleTypeLabels = (): Record<SampleType, string> => ({
  bag: i18n.t("components:addTestModal.sampleType.bag"),
  wax: i18n.t("components:addTestModal.sampleType.wax"),
  liner: i18n.t("components:addTestModal.sampleType.liner"),
  tube: i18n.t("components:addTestModal.sampleType.tube"),
  jar: i18n.t("components:addTestModal.sampleType.jar"),
  quart: i18n.t("components:addTestModal.sampleType.quart"),
  bucket: i18n.t("components:addTestModal.sampleType.bucket"),
  batch: i18n.t("components:addTestModal.sampleType.batch"),
  block: i18n.t("components:addTestModal.sampleType.block"),
  core: i18n.t("components:addTestModal.sampleType.core"),
});
